module.exports = __webpack_public_path__ + "static/media/back-arrow.e97ae255.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/back-arrow.svg
// module id = 538
// module chunks = 0